// extracted by mini-css-extract-plugin
module.exports = {"buttons":"FittingOrders_buttons__UsffN","button":"FittingOrders_button__1CGLF"};